import { Component, ReactNode } from 'react';

import { ZoomFatalError } from '../ZoomFatalError';

interface ZoomErrorBoundaryProps {
  children: ReactNode;
}

interface ZoomErrorBoundaryState {
  hasError: boolean;
}

// No boundary previously wrapped /zoom/* — an uncaught render exception
// anywhere in the Zoom app tree was a permanent blank screen with no recovery.
export class ZoomErrorBoundary extends Component<
  ZoomErrorBoundaryProps,
  ZoomErrorBoundaryState
> {
  constructor(props: ZoomErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ZoomErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ZoomErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ZoomFatalError />;
    }

    return this.props.children;
  }
}
